import { render } from "./ReplyComment.vue?vue&type=template&id=bcd61f72"
import script from "./ReplyComment.vue?vue&type=script&lang=js"
export * from "./ReplyComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__